export default __webpack_public_path__ + "static/media/trialMessageicon.be4667f3.png";